"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollListeners = exports.ScrollListeners = void 0;
var ContainerListener_1 = require("./ContainerListener");
var ScrollListeners = /** @class */ (function () {
    function ScrollListeners() {
        this.activeListeners = [];
    }
    ScrollListeners.prototype.applyScrolling = function (cb) {
        this.activeListeners.forEach(function (listener) {
            return listener.startListeningToScrollOnUserInteraction();
        });
        cb();
    };
    ScrollListeners.prototype.create = function (onScroll, container, onUserInteraction) {
        var containerListener = new ContainerListener_1.ContainerListener(onScroll, container, onUserInteraction);
        this.activeListeners.push(containerListener);
        return containerListener;
    };
    ScrollListeners.prototype.destroy = function (containerListener) {
        containerListener.stopListeningToAll();
        this.activeListeners = this.activeListeners.filter(function (listener) { return listener !== containerListener; });
    };
    return ScrollListeners;
}());
exports.ScrollListeners = ScrollListeners;
exports.scrollListeners = new ScrollListeners();
//# sourceMappingURL=scroll-listeners.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/ScrollListeners/scroll-listeners.js
// module id = 1009
// module chunks = 8